import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable } from '../helper';
import ErrorModal from '../../../components/errorModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class AdjustFreeCardCoverage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            paymentMethods: [],
            reasonsFreeCard: []
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }
    getReasonsFreeCard = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let reasonsFreeCard = [];
        if (cancellationReasons?.length) {
            reasonsFreeCard = cancellationReasons.map((reason, rIdx) => {
                return {
                    ...reason,
                    key: rIdx
                }
            });
        }
        return reasonsFreeCard;
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        let form = {
            patientId: paymentData?.patientData?._id,
            price: paymentData?.amount?.value ? String(paymentData.amount.value) : '0',
            paidPrice: paymentData?.amount?.value ? String(paymentData.amount.value) : '0',
            remainingPrice: '0',
            currency: currency,
            addVatRate: paymentData?.vat?.rate ? true : false,
            vatRate: paymentData?.vat?.rate ?? 0,
            paymentMethods: paymentData?.paymentMethods ?? [],
            reasonFreeCard: -1,
            note: '',
            messageToPatient: '',
            attachedInvoice: null,
        }

        const reasonsFreeCard = this.getReasonsFreeCard() || [];


        this.setState({ form, currency, reasonsFreeCard }, () => {
            if (this.state.form?.patientId) {
                this.findPatient();
            }
        })
    }
    checkPaymentMethods = () => {

        const groupData = this.getGroupData();

        const paymentMethods = getGroupPaymentMethods(groupData, this.props.lang);

        let setObj = { paymentMethods };

        this.setState(setObj)
    }
    findPatient = () => {
        let form = this.state.form;
        const patientId = form.patientId || null;
        const groupId = this.props.selectedGroup || null;
        if (patientId && patientId?.length === 24 && groupId) {

            fetch(API_ENDPOINT + `/api/payments/patient-data/${groupId}/${patientId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?._id) {
                    let patientData = { ...result };
                    let form = {
                        ...this.state.form,
                        patientData: patientData
                    };
                    this.setState({ form }, () => {
                        this.checkPaymentMethods();
                    });
                }
            })

        }
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();

        // this.checkIfExtendedPaymentManagementEnabled();
    }
    checkIfExtendedPaymentManagementEnabled = () => {
        const groupData = this.getGroupData();
        if (groupData?._id) {
            const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
            if (!EXTENDED_PAYMENT_MANAGEMENT) {
                // this.onClose();
            }
        }
    }
    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }

    uploadDocument = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {

            let fsize = input.files[0].size;
            let file = Math.round((fsize / 1024))
            this.setState({
                uploadTimestampDoc: Math.floor(new Date().getTime() / 1000)
            })
            if (file > 10240) {
                this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
            } else {

                if (!this.props.handleFileUpload) this.setState({
                    _documentUploading: true
                })

                let formData = new FormData();
                formData.append('file', input.files[0]);
                formData.append('group', this.props.selectedGroup);
                formData.append('fileType', 'invoices')

                if (this.props.handleFileUpload) {
                    this.props.handleFileUpload?.('/data/upload-document', formData)?.then?.(result => {
                        if (result) {
                            this.setState({
                                attachedInvoiceFile: result,
                                _documentUploading: null
                            })
                        }
                    })
                    return;
                }

                fetch(API_ENDPOINT + '/data/upload-document', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    },
                    body: formData
                }).then(parseText).then(({ result, status }) => {
                    if (status != 200) {
                        this.setState({ error: result.translate(this.props.lang) })
                    } else {
                        this.setState({
                            attachedInvoiceFile: result,
                            _documentUploading: null
                        })
                    }
                })
            }
        }
    }

    toggleAttachInvoiceModal = () => {
        this.setState({ attachInvoiceModal: !this.state.attachInvoiceModal, attachedInvoiceFile: null })
    }

    selectDifferentPatient = () => {
        let form = this.state.form;
        form.patientData = null;
        form.patientId = null;
        this.setState({ form })
    }
    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }
        const reasonFreeCard = this.state.reasonsFreeCard?.find(r => String(r.key) === String(form?.reasonFreeCard)) || null;
        const data = {
            price: form?.price && Number(form?.price) ? Number(form?.price) : 0,
            paidPrice: form?.paidPrice && Number(form?.paidPrice) ? Number(form?.paidPrice) : 0,
            remainingPrice: form?.remainingPrice && Number(form?.remainingPrice) ? Number(form?.remainingPrice) : 0,
            paymentMethods: form?.paymentMethods || [],
            note: form?.note && form?.note.trim() ? form?.note.trim() : '',
            messageToPatient: form?.messageToPatient && form?.messageToPatient.trim() ? form?.messageToPatient.trim() : '',
            reasonFreeCard: reasonFreeCard ? { en: reasonFreeCard.en, se: reasonFreeCard.se } : null,
            attachedInvoice: form?.attachedInvoice || null,
        }


        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/register-payment/free-card/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};

        const price = form?.price && Number(form?.price) ? Number(form?.price) : 0;
        const paidPrice = form?.paidPrice && Number(form?.paidPrice) ? Number(form?.paidPrice) : 0;
        const remainingPrice = form?.remainingPrice && Number(form?.remainingPrice) ? Number(form?.remainingPrice) : 0;
        const paymentMethods = form?.paymentMethods || [];
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        const reasonFreeCard = this.state.reasonsFreeCard?.find(r => String(r.key) === String(form?.reasonFreeCard)) || null;
        const messagesToPatient = form?.messageToPatient && form?.messageToPatient.trim() ? form?.messageToPatient.trim() : '';


        if (remainingPrice === 0 && paidPrice === price) return null;

        if (remainingPrice > 0 && !form?.paymentMethods?.length) {
            errors.paymentMethods = 'Payment method is required'.translate(this.props.lang);
        }
        if (
            remainingPrice > 0
            && form?.paymentMethods?.length === 1
            && form?.paymentMethods?.[0] === 'invoice'
            && !form?.attachedInvoice
        ) {
            errors.attachedInvoice = 'The invoice must be attached'.translate(this.props.lang);
        }


        if (!reasonFreeCard && this.state.reasonsFreeCard?.length) errors.reasonFreeCard = 'Reason for change is required'.translate(this.props.lang);
        const isReasonFreeCardOther = reasonFreeCard && (reasonFreeCard?.en?.trim().toLowerCase() === 'other' || reasonFreeCard?.se?.trim().toLowerCase() === 'other');
        if (((!reasonFreeCard && !errors.reasonFreeCard) || isReasonFreeCardOther) && !note) errors.note = 'Note is required'.translate(this.props.lang);

        return Object.keys(errors).length ? errors : null;


    }
    getBasicPaymentInfo = (data) => {
        const currency = data?.currency;
        const paymentData = this.state.paymentData;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;


        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN
        };

        return response;
    }
    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const currency = this.getCurrency();
        const paymentMethods = this.state.paymentMethods ?? [];
        const price = this.state.form?.price && Number(this.state.form?.price) ? Number(this.state.form?.price) : 0;
        const paidPrice = this.state.form?.paidPrice && Number(this.state.form?.paidPrice) ? Number(this.state.form?.paidPrice) : 0;
        const remainingPrice = this.state.form?.remainingPrice && Number(this.state.form?.remainingPrice) ? Number(this.state.form?.remainingPrice) : 0;
        const errors = this.state.errors ?? {};

        const vatRate = paymentData?.vat?.rate ? Number(paymentData.vat.rate) : 0;

        const basicPaymentInfo = this.getBasicPaymentInfo({ currency });
        return (
            <>
                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Adjust free card coverage'.translate(this.props.lang)}
                        <div className='modal-header-subtitle'>
                            {"Adjust the covered amount if the Frikort doesn't cover the full visit cost. A new payment request will be created for the remaining balance.".translate(this.props.lang)}
                        </div>
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            {/* <Col lg='12'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.questionaryName ? `${basicPaymentInfo.questionaryName} - ` : ''}<span>{basicPaymentInfo.price}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {'Case ID'.translate(this.props.lang)}: <span>{basicPaymentInfo.caseNumber}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.patientName} ({basicPaymentInfo.patientSSN})
                                    </div>
                                </div>
                            </Col> */}
                            <Col lg='12'>
                                <FormGroup className={errors.paidPrice ? 'fg-has-error' : ''} style={{ marginBottom: 0 }}>
                                    <Label>{'Amount covered by free card'.translate(this.props.lang)}</Label>
                                    <div className='price-field-wrap'>
                                        <Input
                                            type='text'
                                            value={this.state.form?.paidPrice || '0'}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value?.length > 11) return;
                                                let form = this.state.form;
                                                form.paidPrice = Number(value);
                                                if (form.paidPrice > price) {
                                                    form.paidPrice = price;
                                                }
                                                form.remainingPrice = price - Number(form.paidPrice);

                                                let setObj = { form };
                                                if (this.state.errors?.paidPrice) {
                                                    let errors = this.state.errors;
                                                    delete errors.paidPrice;
                                                    setObj.errors = errors;
                                                }
                                                this.setState(setObj);
                                            }}
                                        />
                                        {currency}
                                        {
                                            vatRate > 0 ?
                                                <div className='vat-rate-text'>
                                                    {`(${`${vatRate}% ${'VAT included'.translate(this.props.lang)}`})`}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>

                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup className={errors.paidPrice ? 'fg-has-error' : ''}>
                                    {errors.paidPrice ? <div className='error-feedback'>{errors.paidPrice}</div> : null}
                                    <div className='field-info-text' style={{ marginTop: 5 }}>{'This amount will be automatically be marked as paid'.translate(this.props.lang)}</div>
                                </FormGroup>
                            </Col>

                            <Col lg='12'>
                                <FormGroup className={errors.remainingPrice && false ? 'fg-has-error' : ''}>
                                    <Label>{'Remaining balance to be paid'.translate(this.props.lang)}</Label>
                                    <div className='price-field-wrap'>
                                        <Input
                                            type='text'
                                            value={this.state.form?.remainingPrice || '0'}
                                            disabled={true}
                                            onChange={(e) => {
                                                return true;
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value?.length > 11) return;
                                                let form = this.state.form;
                                                form.remainingPrice = Number(value);

                                                let setObj = { form };
                                                if (this.state.errors?.remainingPrice) {
                                                    let errors = this.state.errors;
                                                    delete errors.remainingPrice;
                                                    setObj.errors = errors;
                                                }
                                                this.setState(setObj);
                                            }}
                                        />
                                        {currency}
                                        {
                                            vatRate > 0 && remainingPrice ?
                                                <div className='vat-rate-text'>
                                                    {`(${`${vatRate}% ${'VAT included'.translate(this.props.lang)}`})`}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>

                                </FormGroup>
                            </Col>


                            {
                                paymentMethods?.length && remainingPrice ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.paymentMethods ? 'fg-has-error' : ''}>
                                            <Label>{'Payment method'.translate(this.props.lang)}</Label>
                                            <div className='payment-methods-items-wrap'>
                                                {
                                                    paymentMethods?.map((item, idx) => {
                                                        const isChecked = this.state.form?.paymentMethods?.includes(item.value);
                                                        const isDisabled = price > 0 ? false : true;
                                                        return (
                                                            <div key={idx} className='payment-method-item'>
                                                                <Checkbox
                                                                    checked={isChecked}
                                                                    disabled={isDisabled}
                                                                    onChange={() => {
                                                                        if (isDisabled) return;
                                                                        let form = this.state.form;
                                                                        if (form.paymentMethods?.includes(item.value)) {
                                                                            form.paymentMethods = form.paymentMethods.filter(method => method !== item.value);
                                                                        } else {
                                                                            form.paymentMethods = [...(form.paymentMethods || []), item.value];
                                                                        }
                                                                        let setObj = { form };
                                                                        if (this.state.errors?.paymentMethods) {
                                                                            let errors = this.state.errors;
                                                                            delete errors.paymentMethods;
                                                                            setObj.errors = errors;
                                                                        }
                                                                        this.setState(setObj);
                                                                    }}
                                                                    label={
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                                                                            {item.label}
                                                                            {
                                                                                isChecked && item.value === 'invoice' ?
                                                                                    <div className='icon-with-tooltip-wrap' onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        let attachedInvoiceFile = this.state.form?.attachedInvoice ?? null;
                                                                                        this.setState({ attachInvoiceModal: true, attachedInvoiceFile });
                                                                                    }}>
                                                                                        <Isvg src={attachInvoice} className={errors?.attachedInvoice ? 'attached-invoice-icon-error' : this.state.form?.attachedInvoice ? 'attached-invoice-icon' : ''} />
                                                                                        <div className='tooltip-text'>
                                                                                            {
                                                                                                !this.state.form?.attachedInvoice ?
                                                                                                    'Attach invoice'.translate(this.props.lang)
                                                                                                    :
                                                                                                    'Invoice successfully attached'.translate(this.props.lang)
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    }
                                                                />

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {errors?.paymentMethods ? <div className='error-feedback'>{errors.paymentMethods}</div> : this.state.form?.paymentMethods?.includes('invoice') && errors?.attachedInvoice ? <div className='error-feedback'>{errors.attachedInvoice}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                remainingPrice && this.state.reasonsFreeCard?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.reasonFreeCard ? 'fg-has-error' : ''}>
                                            <Label>{'Reason for change'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='select'
                                                value={this.state.form?.reasonFreeCard || -1}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (!value) value = -1;
                                                    let form = this.state.form;
                                                    form.reasonFreeCard = value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.reasonFreeCard || this.state.errors?.note) {
                                                        let errors = this.state.errors;
                                                        delete errors.reasonFreeCard;
                                                        delete errors.note;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            >
                                                <option value={-1}>{'Select reason'.translate(this.props.lang)}</option>
                                                {
                                                    this.state.reasonsFreeCard?.map((item, idx) => {
                                                        let reason = item?.[this.props.lang] ? item?.[this.props.lang] : item?.['se'];
                                                        return <option value={item?.key}>{reason}</option>
                                                    })
                                                }


                                            </Input>
                                            {errors.reasonFreeCard ? <div className='error-feedback'>{errors.reasonFreeCard}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }

                            {
                                remainingPrice ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.note ? 'fg-has-error' : ''}>
                                            <Label>{'Note'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='textarea'
                                                value={this.state.form?.note || ''}
                                                style={{ height: 100 }}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.note = e.target.value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.note) {
                                                        let errors = this.state.errors;
                                                        delete errors.note;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            />
                                            {errors.note ? <div className='error-feedback'>{errors.note}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                remainingPrice ?
                                    <Col lg='12'>
                                        <FormGroup>
                                            <Label className='note-label-wrap'>
                                                {'Message to patient'.translate(this.props.lang)}
                                                <div className='notes-icon-wrap'>
                                                    <Isvg src={notesIcon} />
                                                    <div className='tooltip-text'>{'Message to patient tooltip'.translate(this.props.lang)}</div>
                                                </div>
                                            </Label>
                                            <Input
                                                type='textarea'
                                                value={this.state.form?.messageToPatient || ''}
                                                style={{ height: 100 }}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.messageToPatient = e.target.value;
                                                    this.setState({ form });
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate}
                        >
                            {'Save'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                <input ref={(node) => this.documentInput = node} type="file" accept=".pdf" key={this.state.uploadTimestampDoc} onChange={this.uploadDocument} style={{ pointerEvents: 'none', opacity: 0 }} />

                {
                    this.state.attachInvoiceModal ?
                        <Modal
                            isOpen={this.state.attachInvoiceModal}
                            centered
                            toggle={() => this.toggleAttachInvoiceModal()}
                        >
                            <ModalHeader toggle={() => this.toggleAttachInvoiceModal()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggleAttachInvoiceModal()}><Isvg src={xIcon} /></button>}>{'Attach invoice'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody style={{ width: '100%' }}>

                                <button
                                    className={this.state._documentUploading ? 'attach-invoice uploading' : this.state.attachedInvoiceFile ? 'attach-invoice uploaded' : "attach-invoice"}
                                    onClick={() => {
                                        if (this.documentInput) this.documentInput.click()
                                    }}
                                >
                                    <div className="button-menu-icon-wrap">
                                        <Isvg src={attachInvoice} />
                                    </div>
                                    <div className='chat-icons-text'>
                                        {
                                            this.state.attachedInvoiceFile ?
                                                'File uploaded'.translate(this.props.lang)
                                                :
                                                'Attach file'.translate(this.props.lang)
                                        }
                                    </div>
                                </button>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={!this.state.attachedInvoiceFile}
                                    onClick={() => {
                                        let form = this.state.form;
                                        form.attachedInvoice = this.state.attachedInvoiceFile;
                                        let setObj = { form };
                                        if (this.state.errors?.attachedInvoice) {
                                            let errors = this.state.errors;
                                            delete errors.attachedInvoice;
                                            setObj.errors = errors;
                                        }
                                        this.setState(setObj, () => {
                                            this.toggleAttachInvoiceModal();
                                        });
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => this.toggleAttachInvoiceModal()}>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>


                        </Modal>
                        :
                        null
                }

                {this.state._documentUploading ?
                    <div className="file-progress-loader">
                        <div>
                            <Player
                                onEvent={(event) => {
                                    if (event === "load" && this.player && this.player.current) this.player.current.play();
                                }}
                                ref={this.player} // set the ref to your class instance
                                autoplay={true}
                                loop={true}
                                controls={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                renderer={'svg'}
                                style={{ height: "128px", width: "128px", }}
                            ></Player>
                            <h6>{'Processing file...'.translate(this.props.lang)}</h6>
                        </div>
                    </div>
                    : null}

            </>
        );
    }
}


export default AdjustFreeCardCoverage;